
<div class="card mb-4 box-shadow">
  <img class="card-img-top flex-auto d-md-block" src="{{data.imageUrl}}" alt="{{data.fullName}}" />
  <div class="card-body d-flex flex-column">
    <h4 class="mb-0">
      {{data.fullName}}
    </h4>
    <p class="card-role mb-0">{{data.title}}</p>
    <!-- <a routerLink="/about/{{data.url}}" class="btn btn-primary advisorButtons">View Profile</a> -->
  </div>
</div>